import React, { useContext } from 'react';
import { makeStyles, Theme } from '@material-ui/core';
import { CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import { CompanyInfoContext } from '../context/CompanyInfoContext';
import { responseTimeFormatter } from '@utils/formatter';
import { StarFilled } from '@carbon/icons-react';
interface CompanyStatisticProps {
  isRequest?: boolean;
}

const CompanyStatistic: React.FunctionComponent<CompanyStatisticProps> = ({
  isRequest = false
}) => {
  const { companyStatisticContainer } = useStyles({ isRequest });
  const context = useContext(CompanyInfoContext);

  const partnerInfo = context?.partnerInfo;
  const reviewAveragePoint = partnerInfo?.reviews?.reviewAveragePoint ?? 0.0;

  return (
    <div className={companyStatisticContainer}>
      <div className="statistics-entry">
        {partnerInfo?.transactionCount ? (
          <CustomizedTypography
            className="statistics-entry-value"
            fontWeight="700"
          >
            {partnerInfo?.transactionCount} 회
          </CustomizedTypography>
        ) : (
          <CustomizedTypography className="statistics-no-entry-value">
            아직 없음
          </CustomizedTypography>
        )}

        <CustomizedTypography className="statistics-entry-key">
          거래 수
        </CustomizedTypography>
      </div>
      <div className="statistics-entry">
        {partnerInfo?.averageResponseTime ? (
          <CustomizedTypography className="statistics-entry-value">
            {responseTimeFormatter(partnerInfo?.averageResponseTime)}
          </CustomizedTypography>
        ) : (
          <CustomizedTypography className="statistics-no-entry-value">
            아직 없음
          </CustomizedTypography>
        )}

        <CustomizedTypography className="statistics-entry-key">
          평균 응답 시간
        </CustomizedTypography>
      </div>
      <div className="statistics-entry">
        <div className="satisfaction-section">
          {reviewAveragePoint !== 0.0 ? (
            <>
              <StarFilled
                color={colorSet.primary500}
                size={16}
                className="star"
              />
              <CustomizedTypography className="statistics-entry-value">
                {reviewAveragePoint.toFixed(1)}{' '}
              </CustomizedTypography>
              <CustomizedTypography className="reviewBar">
                /
              </CustomizedTypography>
              <CustomizedTypography className="reviewRating">
                5
              </CustomizedTypography>
            </>
          ) : (
            <CustomizedTypography className="statistics-no-entry-value">
              아직 없음
            </CustomizedTypography>
          )}
        </div>

        <CustomizedTypography className="statistics-entry-key">
          고객 만족도
        </CustomizedTypography>
      </div>
    </div>
  );
};

export default CompanyStatistic;

const useStyles = makeStyles<Theme, Pick<CompanyStatisticProps, 'isRequest'>>(
  (theme) => ({
    companyStatisticContainer: {
      display: 'flex',
      width: '100%',
      borderRadius: ({ isRequest }) => (isRequest ? 0 : 12),
      border: `1px solid ${colorSet.gray400}`,
      borderRight: ({ isRequest }) =>
        isRequest ? 0 : `1px solid ${colorSet.gray400}`,
      borderLeft: ({ isRequest }) =>
        isRequest ? 0 : `1px solid ${colorSet.gray400}`,
      padding: '22px 0px',
      justifyContent: 'space-around',
      '& .statistics-entry': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'cneter',
        justifyContent: 'center',
        '& .statistics-entry-value': {
          ...theme.typography.body1,
          color: colorSet.gray900,
          fontWeight: 700,
          textAlign: 'center'
        },
        '& .statistics-no-entry-value': {
          ...theme.typography.body1,
          color: colorSet.gray700,
          textAlign: 'center'
        },
        '& .statistics-entry-key': {
          ...theme.typography.body2,
          color: colorSet.gray900,
          textAlign: 'center'
        },
        '& .satisfaction-section': {
          display: 'flex',
          alignItems: 'cneter',
          justifyContent: 'space-between',
          '& .reviewBar': {
            color: colorSet.gray600,
            fontSize: 12,
            marginTop: 3
          },
          '& .reviewRating': {
            color: colorSet.gray600
          },
          '& .star': {
            position: 'relative',
            bottom: '-4px',
            marginRight: 3,
            [theme.breakpoints.down('xs')]: {
              marginRight: 3
            }
          }
        }
      }
    }
  })
);
